import { Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'

const DisplayData = ({ icone, descricao, valor }) => {
    return (
        <Grid container
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignContent: 'center'
            }} >
            <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', height: '35%', width: '100%' }}>
                <img src={icone} alt="icone" />
            </div>
            <Typography fontSize="17px" fontWeight="600" textAlign="center">{descricao}</Typography>
            <Typography fontSize="31px" fontWeight="600" textAlign="center" color="#590CFB">{valor}</Typography>
        </Grid>
    )
}

export default DisplayData
